import firebase from 'firebase';
import 'firebase/firestore';
import config from './config';

export const firebaseImpl = firebase.initializeApp(config.firebase);
export const firestore = firebase.firestore();